import * as api from '../util/apis';
import { ENV } from '../constants/Constants';
import { Template } from '@horasys/bellplus/common/types';
import { generateJson, getTemplateFromJson } from '../jsonutils/template';
import { UPLOAD_ASSET_TYPE } from './advertising.service';

export const getTemplatesList = async (): Promise<Array<Template>> => {
	try {
		const resp: any = await api.getapiresponses(ENV.dev.template);
		const templateJsonList = resp.data.data.client;
		const templateList: Array<Template> = templateJsonList.map(
			(jsonTemplate: any) => {
				return getTemplateFromJson(jsonTemplate);
			},
		);
		return Promise.resolve(templateList);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getTemplateStandardList = async (): Promise<Array<Template>> => {
	try {
		const resp: any = await api.getapiresponses(ENV.dev.template);
		const templateJsonList = resp.data.data.standard;
		const templateList: Array<Template> = templateJsonList.map(
			(jsonTemplate: any) => {
				return getTemplateFromJson(jsonTemplate);
			},
		);
		return Promise.resolve(templateList);
	} catch (error) {
		return Promise.reject(error);
	}
};


export const getTemplatesListByDeviceTypeId = async (
	deviceTypeId: number,
): Promise<Array<Template>> => {
	try {
		const resp: any = await api.getapiresponses(
			ENV.dev.template + '/?deviceTypeId=' + deviceTypeId,
		);
		const templateJsonList = resp.data.data;
		const clientList = templateJsonList.client;
		const standardList = templateJsonList.standard;
		const totalList: Array<Template> = [];
		clientList.forEach((jsonTemplate: any) => {
			totalList.push(getTemplateFromJson(jsonTemplate));
			return;
		});
		standardList.forEach((jsonTemplate: any) => {
			totalList.push(getTemplateFromJson(jsonTemplate));
			return;
		});
		return Promise.resolve(totalList);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getTemplateById = async (templateId: number): Promise<Template> => {
	try {
		const resp: any = await api.getapiresponses(ENV.dev.template + '/' + templateId);
		const template: Template = getTemplateFromJson(resp.data.data);
		return Promise.resolve(template);
	} catch (error) {
		return Promise.reject(error);
	}
};

export const createTemplate = async (template: Template) => {
	const requestData = generateJson(template, 'CREATE');
	const resp = await api.postapiresponses(ENV.dev.template, requestData);
	return resp;
};

export const updateTemplate = async (template: Template, templateId: number) => {
	const requestData = generateJson(template, 'UPDATE');
	const resp: any = await api.putapiresponses(
		ENV.dev.template + '/' + templateId,
		requestData,
	);
	return resp;
};

export const deleteTemplate = async (templateId: any):Promise<any> => {
	try{
		const resp: any = await api.deleteapiresponses(ENV.dev.template + '/' + templateId);
		return Promise.resolve(resp)
	}catch(error){
		return Promise.reject(error)
	}
};

export const uploadAsset = async (assetBlob: any, uploadAssetType: UPLOAD_ASSET_TYPE) => {
	const formData = new FormData();
	formData.append('file', assetBlob);

	const config = {
		onUploadProgress: function (progressEvent: any) {
			console.log(progressEvent);
		},
	};

	const resp: any = await api.uploadapiresponses(
		ENV.dev.uploadassets + '?type=' + uploadAssetType,
		formData,
		config,
	);
	return resp;
};
